<template>
	<bsh-modal 
		titulo="Editar Material"
		:name="name"
        tamanho="modal-lg">
		<template v-slot:default>
	        <material-form
	        	:dados="dados" 
	        	:name="name" 
	        	:errors="errors">
	        </material-form>
	    </template>
	    <template v-slot:footer>
        	<button 
				ref="btnRequest"
        		type="button" 
        		class="btn btn-primary" 
        		@click="update">
        		Salvar
        	</button>
        </template>
    </bsh-modal>
</template>

<script>
	export default {
		props: ['dado_id'],
		data(){
			return {
				dados: [],
				name: 'update_produto_material',
				errors: []
			}
		}, 
		methods: {
			update(){
				this.$btnFunctions.disableToggle(this.$refs.btnRequest, true)
	            axios.put(this.$url+'/api/adm/produto-materiais/update/'+this.dado_id, (this.dados))
	            .then(response => {
	            	$('#'+this.name).modal('hide')
	            	this.$bshMessage.show(response.data.message, response.data.type)
	              	this.$emit('reload')
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
	            })
	            .catch(error => {
					this.errors = error.response.data.errors
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
				});
        	},
        	getDados(){
	            axios.get(this.$url+'/api/adm/produto-materiais/show/'+this.dado_id)
	            .then(response => {
	                this.dados = response.data
	            })
			}
		},
		watch: {
			dado_id(){
				this.getDados()
			}
		}
	}
</script>